import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/permissions/route-guard";

export const Route = createFileRoute("/_authenticated/suppliers")({
  component: SuppliersLayout,
});

function SuppliersLayout() {
  return (
<RouteGuardPermissions
      permissions={[{ module: "suppliers", actions: ["read"] }]}>
      
    <RouteGuard module="suppliers" action="read">
      <Outlet />
    </RouteGuard>
  
    </RouteGuardPermissions>
  );
}
